import React, { useEffect, useState } from "react";
import api from "../lib/api";
import ArtistListingCard from "./ArtistListingCard";

export default function ArtistRecommendations({ title = "You may also like", testId = "artist-recommendations" }) {
  const [artists, setArtists] = useState([]);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    api.get("/artists/featured?limit=5")
      .then(({ data }) => {
        if (active) {
          setArtists(Array.isArray(data) ? data : []);
          setError("");
          setLoaded(true);
        }
      })
      .catch(() => {
        if (active) {
          setError("Suggested artists could not be loaded.");
          setLoaded(true);
        }
      });
    return () => { active = false; };
  }, [retry]);

  return (
    <section className="artist-recommendations" aria-labelledby={`${testId}-title`} data-testid={testId}>
      <div className="artist-recommendations-heading">
        <div>
          <h2 id={`${testId}-title`}>{title}</h2>
          <p>Explore a few popular artists while you adjust your search.</p>
        </div>
      </div>
      {artists.length > 0 ? (
        <div className="artist-grid-v2">
          {artists.map((artist) => (
            <ArtistListingCard
              key={artist.user_id}
              artist={artist}
              testId={`${testId}-artist-${artist.user_id}`}
            />
          ))}
        </div>
      ) : error ? (
        <div className="artist-recommendations-error" role="status">
          <span>{error}</span>
          <button type="button" className="btn btn-ghost btn-xs" onClick={() => {
            setLoaded(false);
            setRetry((value) => value + 1);
          }}>
            Try again
          </button>
        </div>
      ) : loaded ? (
        <div className="text-muted fs-13" role="status">No suggested artists are available right now.</div>
      ) : (
        <div className="text-muted fs-13" role="status">Finding artists you may like…</div>
      )}
    </section>
  );
}
